export const images = {
  registerBtn:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732547476/register-btn_zyjq4m.svg',
  loginBtn:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732547475/login-btn_qz8wz8.svg',
  registerBtnDesktop:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732547476/register-btn-desktop_tlozwn.svg',
  logo: 'https://res.cloudinary.com/drejchdwh/image/upload/v1732547474/anizone-logo_zfm3gz.svg',
  menuWhiteBtn:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733209031/menu-white-btn_whdl3r.svg',
  unloggedIcon:
    'https://pub-60946b28fb374ff48942bac3163dd658.r2.dev/user-icon-default_olftzk.svg',
  closeMenu:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732547475/close-shur_apoig6.svg',
  darkMode:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732547474/darkmode_aemmyg.svg',
  lightMode:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732547474/lightmode_nteeu4.svg',
  loginDesktopBtn:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733207101/desktop-login-btn_cejqtm.svg',
  registerDesktopBtn:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733208459/desktop-register-btn_bjawun.svg',
  redDivider:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733952605/redte_otexbr.svg',
  redBorder:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1737556010/red-border_gct9cm.png',
}

export const heroImages = {
  readMore:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733215207/read-more-btn_gwve4b.svg',
  emptyGreyBlock:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732602695/empty-greyblock_bigqcs.svg',
  emptyRedBlock:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732602695/empty-redblock_lnf1te.svg',
  imgOne:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733215291/demo1_vlvnh3.jpg',
  imgTwo:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733215313/demo2_pbgoj3.jpg',
  imgThree:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733215325/demo3_pvzigq.jpg',
}

export const topAnimesImages = {
  selectedTrailer:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1739027580/selectedtrailernew_n2hwa3.svg',
  unSelectedTrailer:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732714382/unplay-trailer_zkv4wj.svg',
  selectedWatchlist:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732629076/selected-watchlist_wpipty.svg',
  unSelectedWatchlist:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732629076/unselected-watchlist_vg0jty.svg',
  yearRedBlock:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732629076/year-trailer_zggoqj.svg',
  allAnimesTitle:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733220778/all-animes-btn_xzsjuu.svg',
  arrowLeft:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732711236/left-arrow_mudfaz.svg',
  arrowRight:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732711236/right-arrow_rp1nmg.svg',
}

export const animeSchedule = {
  fullBoard:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732779399/full-board-btn_xlkgnl.svg',
  timeBoard:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732779399/time-schedule_c5yqjo.svg',
  redBlockSchedule:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732779399/red-block-date-schedule_i2xkjm.svg',
  greyBlockSchedule:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732779399/grey-block-date-schedule_u3u0nn.svg',
  mailIcon:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732779399/mail-icon_rx7dp1.svg',
  redBlock:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732779399/red-block-schedule_ttw7pj.svg',
  greyBlock:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732779401/grey-block-schedule_t7djpo.svg',
  redDot:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732796751/red-dot_slqjuf.svg',
  greyDot:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732796751/white-dot_t7q9b4.svg',
  arrowRight:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732796751/right-arrow_n8osuj.svg',
  arrowLeft:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1732796751/left-arrow_p3l3xy.svg',
}

export const signUpImages = {
  divider:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733058879/divider_znhlou.svg',
  googleIcon:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733058879/google-icon_iieadq.svg',
  discordIcon:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733058879/discord-icon_etqadk.svg',
  passwordHide:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733058879/password-hide_dcax4g.svg',
  passwordShow:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733058879/password-show_vboipd.svg',
}

export const articelsHomePageImages = {
  allArticelsBtn:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733651232/all-articels-btn_mhi79r.svg',
  newArticelsDivider:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733651232/top-article-divider_bwy5cp.svg',
  topArticelsDivider:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733651232/new-articles-divider_e3jwq2.svg',
  redAlertCircle:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733733350/alert-circle_wgmymq.svg',
  imgDividerMobile:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733735007/new-img-divider_yh2bs2.svg',
  sectionDivider:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733736303/sections-divider_fcqrpy.svg',
  lineXDivider:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733765436/line-divider_fdfsbp.svg',
  unlikedBtn:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733738865/unliked_lgh2sj.svg',
  likedBtn:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733760057/liked_qeifbv.svg',
  shareMobileBtn:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733738865/share-mobile-btn_qxi87z.svg',
  commentBtn:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733738865/comment_ofq6at.svg',
  editBtn:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733762622/edit-btn_ye8fw2.svg',
  moreInfoIcon:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733755129/more-info-icon_wkatfw.svg',
  shareDivider:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733755130/share-divider_qryrsd.svg',
  tiktokIcon:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733755130/tiktok-icon_qmhpgx.svg',
  telegramIcon:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733755131/telegram-icon_atijtq.svg',
  whatsappIcon:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733755131/whatsapp-icon_zr9r8t.svg',
  discordIcon:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733755131/discord-icon_z2lfje.svg',
  arrowIcon:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733778637/arrow_oyebqc.svg',
  yesCharacter:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733853548/yes-character_nrr4ib.svg',
  noCharacter:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733853545/no-character_sl2262.svg',
  japanGuide:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1737313435/japan-travel_nrlnkk.png',
  vocabulary:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1737313435/vocabulery_eycpfe.png',
  beginnersGuide:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1737313434/begginer-guide_ink4fn.png',
}

export const topEditorsImages = {
  lineDivider:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733997137/line-divider_mfmwgo.svg',
}

export const discoverImages = {
  redLineDivider:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1734257212/red-line_uhjskj.svg',
  selectedFact:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1734257212/selected-fact_kjgxyf.svg',
  unselectedFact:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1734257212/unselected-fact_xwui4n.svg',
  btnBg:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1734257212/btn_b0fla1.svg',
  character:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1734257213/character_exsj62.svg',
}

export const postListImages = {
  headerImg:
    'https://pub-60946b28fb374ff48942bac3163dd658.r2.dev/header-postlist.png',
  searchBtn:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1734594765/search-btn_mbgprj.svg',
  searchIcon:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1734594765/search-icon_cyuh60.svg',
  redBlock:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1734608131/news-titles_fu25iq.png',
  fireIcon:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1734608131/fire-icon_cvqy8a.svg',
  popularBlock:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1734608528/popular-block_otlxvx.svg',
  newsTitleDivier:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1734616489/titles-divider_pnarib.svg',
}

export const postListNewImages = {
  blockBanner:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1734871714/block-new_zcyr4j.svg',
  blockIcon:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1734871714/block-icon_x0eupc.svg',
  mostlikedBlock:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1734871759/mostliked-block_xtfcyk.svg',
  starIcon:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1734957922/star-icon_kvyxlr.svg',
  longLineDivider:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1735108301/long-line_z3hnhf.svg',
  blockBtn:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1735108931/block-btn_mn5s5n.svg',
}
export const footerImages = {
  addmeBtn:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733822830/addme-footer.svg_h5zv75.svg',
  characterMain:
    '  https://res.cloudinary.com/drejchdwh/image/upload/v1742740280/Finished_Transparent_BG_1_hm8yf4.png',
  tiktokIcon:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733846010/tiktok-icon_dhlbns.svg',
  youtubeIcon:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733846010/youtube-icon_rotdhb.svg',
  telegramIcon:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733846010/telegram-icon_yrndtd.svg',
  discordIcon:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733846010/discord-icon_vvjh4h.svg',
  instagramIcon:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733846010/instagram-icon_p0dkc9.svg',
}

export const commentImages = {
  lineDivider:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1733997137/line-divider_mfmwgo.svg',
  replyBtn:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1735468513/reply_rqvrdp.svg',
  ellipsisBtn:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1735471143/ellipsis-solid_1_fhe3en.svg',
  pouplarComment:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1735468513/popular-comment_p2rakv.svg',
}

export const userProfileImages = {
  blockBackground:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1735811914/background_astb6d.png',
  quoteIcon:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1735811023/quote-icon_cfodjv.svg',
  arrowDown:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1735806731/arrow-down_jshv46.svg',
  arrowUp:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1735806978/arrow-up_hqzifa.svg',
  plusIcon:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1736837570/plus-icon_ufuwtl.svg',
  minusIcon:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1736849625/minus-icon__h67pxk.svg',
  dotsIcon:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1736850602/dots-icons_nw2aqe.svg',
}

export const animeListImages = {
  planToWatch:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1737290741/add-to-planning_sexug2.svg',
  addToWatch:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1737290741/add-to-watchlist_yrzt25.svg',
}

export const faqImages = {
  begginer:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1739094086/begginer_jpsnoy.png',
  advanced:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1739094086/advenced_ulktzx.png',
  expert:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1739094086/expert_rng4tp.png',
}

export const japanImages = {
  banner:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1741765887/japan-banner_plp4st.png',
  card1:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1741765887/card1_sfzqek.png',
  card2:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1741765887/card2_mfqocw.png',
  card3:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1741765887/card3_fmek0l.png',
  card4:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1741765887/card4_edmdl4.png',
  airwithpin:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1741778040/airplanewithpin_u0aqya.png',
  japanmap:
    'https://res.cloudinary.com/drejchdwh/image/upload/v1742193363/Group_3349_iqlupg.png',
}
